export default "__VITE_ASSET__DxVB$U6Z__"